<nav class="navbar navbar-top navbar-expand navbar-light bg-default border-bottom" id="navbar-main"
  [ngClass]="{'navbar-homolog': production === false }">
  <div class="container-fluid">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <!-- Navbar links -->
      <ul class="navbar-nav align-items-center ml-md-auto">
        <li class="nav-item d-xl-none">
          <!-- Sidenav toggler -->
          <div class="pr-3 sidenav-toggler sidenav-toggler-dark" data-action="sidenav-pin" data-target="#sidenav-main"
            (click)="openSidebar()">
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </li>
        <li>
          <!-- <a class="nav-link text-white mousePointer" data-bs-toggle="modal" data-bs-target="#chatAI" *ngIf="habilitarChat()">
            <i class="material-icons">3p</i>
          </a> -->
          <!-- <a class="nav-link text-white mousePointer" data-bs-toggle="offcanvas" data-bs-target="#chatAI" aria-controls="offcanvasScrolling" *ngIf="habilitarChat()">
            <i class="fa fa-robot"></i>
          </a> -->
          <a class="nav-link text-white mousePointer" href="https://tai.teadit.app/login" target="_blank">
            <i class="fa fa-robot"></i>
          </a>
        </li>
        <li *ngIf="showStock && !isMobileResolution">
          <a class="nav-link text-white mousePointer" data-bs-toggle="modal"
            data-bs-target="#analiseDeEstoqueModal">Estoque</a>
        </li>
        <li *ngIf="!isMobileResolution">
          <a class="nav-link text-white mousePointer" data-bs-toggle="modal"
            data-bs-target="#consultarPedidoModal">Consultar Pedido</a>
        </li>
        <li class="nav-item" *ngFor="let item of items; let i = index"
          [ngClass]="{'dropdown': (item.children.length > 0), 'show': (item.children.length > 0) && isDropdownOpen('menu-' + i)}"
          [hidden]="isMobileResolution">
          <a class="nav-link text-white mousePointer" [hidden]="item.children.length > 0"
            (click)="setUrl(item.module, item.parameter, item.value)">{{item.display}}</a>
          <a class="nav-link text-white dropdown-toggle mousePointer" [hidden]="item.children.length === 0"
            [id]="'navbarDropdown' + i" role="button" href="#"
            [attr.aria-expanded]="isDropdownOpen('menu-' + i)"
            (click)="toggleDropdown('menu-' + i, $event)">
            {{item.display}} {{(getValue(item.value))}}
          </a>
          <ul class="dropdown-menu dropdown-menu-right"
            [ngClass]="{'show': isDropdownOpen('menu-' + i)}" [hidden]="item.children.length === 0"
            [attr.aria-labelledby]="'navbarDropdown' + i">
            <li><a class="dropdown-item mousePointer " *ngFor="let kid of item.children"
                (click)="setUrl(item.module,kid.parameter, kid.value); closeDropdowns()">{{kid.display}}</a></li>
          </ul>
        </li>


      </ul>
      <ul class="navbar-nav align-items-center ml-auto ml-md-0">
        <li class="nav-item dropdown" [ngClass]="{'show': isDropdownOpen('profile')}">
          <a class="nav-link dropdown-toggle" href="#" role="button"
            [attr.aria-expanded]="isDropdownOpen('profile')" (click)="toggleDropdown('profile', $event)">
            <img src="{{photo}}" alt="mdo" width="32" height="32" class="rounded-circle">
          </a>
          <ul class="dropdown-menu dropdown-menu-right" [ngClass]="{'show': isDropdownOpen('profile')}">
            <li><a class="dropdown-item mousePointer" data-bs-toggle="modal"
                data-bs-target="#claimsModal" (click)="closeDropdowns()">{{this.name}}</a>
            </li>
            <li><a class="dropdown-item mousePointer" (click)="closeDropdowns(); logout()">Sair</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div *ngIf="sidenavOpen === true" class="backdrop d-xl-none" (click)="toggleSidenav()"></div>
<app-claims-modal #claimsModal></app-claims-modal>
<app-consultar-pedido-modal></app-consultar-pedido-modal>




<!--



<nav id="navbar" class="navbar navbar-expand-lg navbar-light bg-default header-nav-bar"
  [ngClass]="{'navbar-homolog': production === false }">
  <div class="container-fluid">
    <!-- <img class="me-2" alt="Logo Teadit" height="25" src="https://apmidasstorage.blob.core.windows.net/cdn/logo.png"
      width="25" (click)="redirectHome()"> ->
    <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#navbarOffcanvasLg"
      aria-controls="navbarOffcanvasLg" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <a class="navbar-brand text-white" text-white href="/">MIDAS</a>


    <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item d-xl-none">
          <!-- Sidenav toggler ->
          <div class="pr-3 sidenav-toggler sidenav-toggler-dark" data-action="sidenav-pin" data-target="#sidenav-main"
            (click)="openSidebar()">
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </li>
      </ul>
      <div class="d-flex">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li *ngIf="showStock">
            <a class="nav-link text-white mousePointer" data-bs-toggle="modal"
              data-bs-target="#analiseDeEstoqueModal">Estoque</a>
          </li>
          <li class="nav-item" *ngFor="let item of items" [ngClass]="{'dropdown' : (item.children.length > 0)}">
            <a class="nav-link text-white mousePointer" [hidden]="item.children.length > 0"
              (click)="setUrl(item.module, item.parameter, item.value)">{{item.display}}</a>
            <a class="nav-link text-white dropdown-toggle" [hidden]="item.children.length === 0" id="navbarDropdown"
              role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{item.display}} {{(getValue(item.value))}}
            </a>
            <ul class="dropdown-menu dropdown-menu-right" [hidden]="item.children.length === 0"
              aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item mousePointer " *ngFor="let kid of item.children"
                  (click)="setUrl(item.module,kid.parameter, kid.value)">{{kid.display}}</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <img src="{{photo}}" alt="mdo" width="32" height="32" class="rounded-circle">
            </a>
            <ul class="dropdown-menu dropdown-menu-right">
              <!-- <li><a class="dropdown-item">Configurações</a></li>
              <li><a class="dropdown-item">Perfil</a></li>
              <li>
                <hr class="dropdown-divider">
              </li> ->
              <li><a class="dropdown-item">{{this.name}}</a></li>
              <li><a class="dropdown-item" (click)="logout()">Sair</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="offcanvas offcanvas-end" tabindex="-1" id="navbarOffcanvasLg" aria-labelledby="navbarOffcanvasLgLabel">
    <div class="offcanvas-header bg-primary" [ngClass]="{'navbar-homolog': production === false }">
      <img src="{{photo}}" alt="mdo" width="32" height="32" class="rounded-circle me-2">
      <h5 class="offcanvas-title"> {{name}}</h5>
      <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
      <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
        <li class="nav-item">
          <a class="nav-link" aria-current="page" href="/">Início</a>
        </li>

        <li class="nav-item" *ngIf="showStock">
          <a class="nav-link" data-bs-toggle="modal" data-bs-target="#analiseDeEstoqueModal">Estoque</a>
        </li>


        <li class="nav-item" *ngFor="let item of items" [ngClass]="{'dropdown' : (item.children.length > 0)}">
          <a class="nav-link mousePointer" [hidden]="item.children.length > 0"
            (click)="setUrl(item.module, item.parameter, item.value)">{{item.display}}</a>
          <a class="nav-link dropdown-toggle" [hidden]="item.children.length === 0" id="navbarDropdown" role="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            {{item.display}} {{(getValue(item.value))}}
          </a>
          <ul class="dropdown-menu" [hidden]="item.children.length === 0" aria-labelledby="navbarDropdown">
            <li><a class="dropdown-item mousePointer " *ngFor="let kid of item.children"
                (click)="setUrl(item.module,kid.parameter, kid.value)">{{kid.display}}</a></li>
          </ul>
        </li>
        <li>
          <hr class="dropdown-divider">
        </li>
        <li class="nav-item">
          <a class="nav-link" aria-current="page" (click)="logout()">Sair</a>
        </li>
      </ul>
    </div>
  </div>
</nav>-->


<div class="row" *ngIf="!production">
  <div class="col text-center">
    <div class="homolog-alert">
      Ambiente de homologação
    </div>
  </div>
</div>


<app-chat-ai></app-chat-ai>
